import React from "react";
import { Box, Skeleton, Divider } from "@mui/material";
import ProductCardSkeleton from "./ProductCardSkeleton";

const ListPageSkeleton = ({ showAction = true, sidebarItems = 2, cardCount = 4 }) => {
	return (
		<Box
			className="recommendation-page"
			sx={{
				padding: { xs: "10px", md: "40px" },
				width: "100%",
			}}
		>
			{/* Page Title */}
			<Skeleton variant="text" width={220} height={38} sx={{ mb: 2 }} />

			{/* Action Button */}
			<Box display="flex" justifyContent="flex-end" mb={2}>
				{showAction && <Skeleton variant="rectangular" width={180} height={42} />}
			</Box>

			{/* Main Flex Layout */}
			<Box
				sx={{
					display: "flex",
					gap: 2,
					alignItems: "flex-start",
					width: "100%",
				}}
			>
				{/* Left Sidebar (15%) */}
				<Box
					sx={{
						width: "18%",
						minWidth: "180px",
						display: "flex",
						flexDirection: "column",
						rowGap: 2,
					}}
				>
					<Skeleton variant="rectangular" borderRadius={"10px"} width="100%" height={40} sx={{ mb: 1 }} />
					{Array.from({ length: sidebarItems }).map((_, idx) => (
						<Box
							key={`sidebar-skeleton-${idx}`}
							sx={{
								borderRadius: 2,
								p: 1,
							}}
						>
							<Skeleton variant="text" width="80%" height={24} />
							<Skeleton variant="text" width="60%" height={18} />
						</Box>
					))}
				</Box>

				{/* Divider */}
				<Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

				{/* Right Content Area (flex: 1) */}
				<Box
					sx={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: 2,
						width: "100%",
					}}
				>
					{Array.from({ length: cardCount }).map((_, idx) => (
						<Box
							key={`rectangle-skeleton-${idx}`}
							sx={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
								borderRadius: "10px",


							}}
						>
							<Skeleton variant="rectangular" width="100%" height={45} sx={{ borderRadius: "8px" }} />
						</Box>
					))}
				</Box>
			</Box>
		</Box>
	);
};

export default ListPageSkeleton;
